import { Component, FC } from 'react'
import * as styles from 'components/features/pfm/SidebarPopup/SidebarPeergroupPopup.styl'
import * as cn from 'classnames'
import { Peergroup, PeergroupRelation, RelationId } from 'interfaces/peergroups'
import { BlockCorners, BrandColor } from 'interfaces/component'
import { ViewportSegment } from 'interfaces/viewport'
import { shortenNumber } from 'helpers/formatHelpers'
import { SLUGS } from 'constants/peergroups'
import ButtonRow from 'components/atoms/buttons/ButtonRow'
import Button from 'components/features/pfm/Button/Button'
import { SidebarPopup } from 'components/features/pfm/SidebarPopup/SidebarPopup'
import { SidebarPopupBackButton } from 'components/features/pfm/SidebarPopup/SidebarPopupBackButton'
import { PeerDefinition } from 'components/features/pfm/PeerDefinition/PeerDefinition'
import { preparePeerDefinitionProps } from 'helpers/peergroupsHelpers'
import { SidebarPopupHeader } from 'components/features/pfm/SidebarPopup/SidebarPopupHeader'

export type SidebarPeergroupPopupStateProps = {
  relation: PeergroupRelation
  peergroup: Peergroup
  hideTimeoutId: number | null
  isRandomizing: boolean
  viewportSegment: ViewportSegment
}

export type SidebarPeergroupPopupDispatchProps = {
  onEdit: () => void
  onRemove: () => void
  onRandomize: () => void
  onSelectRelation?: () => void
  onSelectFeedfilter?: () => void

  onHidePopup: () => void
  onRegisterHideTimeout: (timeoutId: number) => void
}

export type SidebarPeergroupPopupOwnProps = {
  isOnFeedPage?: boolean
  relationId: RelationId
  corners: BlockCorners
  onBackButtonClick?: () => void
}

type SidebarPeergroupPopupProps =
  & SidebarPeergroupPopupStateProps
  & SidebarPeergroupPopupDispatchProps
  & SidebarPeergroupPopupOwnProps

export class SidebarPeergroupPopup extends Component<SidebarPeergroupPopupProps> {
  render () {
    const {
      relation, peergroup,
      corners, onBackButtonClick,
      isRandomizing, onRandomize,
      viewportSegment,
      onSelectRelation, onSelectFeedfilter,
      onEdit, onRemove,
      onHidePopup, onRegisterHideTimeout, hideTimeoutId,
      isOnFeedPage,
    } = this.props

    const isYourPeers = relation.slug === SLUGS.peers
    const isPeergroupSelectShown = viewportSegment !== 'desktop' && !isYourPeers
    const isFeedfilterSelectShown = viewportSegment !== 'desktop'

    const selectRelationButton = isPeergroupSelectShown && onSelectRelation && (
      <div className={ styles.footerRow }>
        <Button
          size='small'
          theme='blue'
          onClick={ onSelectRelation }
          text='Select This Group'
          fullWidth
        />
      </div>
    )

    const selectFeedfilterButton = isFeedfilterSelectShown && onSelectFeedfilter && (
      <div className={ styles.footerRow }>
        <Button
          size='small'
          theme='blue'
          onClick={ onSelectFeedfilter }
          text='View Posts'
          fullWidth
        />
      </div>
    )

    const randomizeButton = relation.slug === SLUGS.random && (
      <div className={ styles.footerRow }>
        <Button
          size='small'
          theme='lightBlue'
          fullWidth
          onClick={ onRandomize }
          isSubmitting={ isRandomizing }
          disabled={ isRandomizing }
        >
          Randomize
        </Button>
      </div>
    )

    const customGroupButtons = !relation.is_preset && (
      <div className={ styles.footerRow }>
        <ButtonRow
          size='tiny'
          buttons={ [
            { text: 'Edit', onClick: onEdit, theme: 'lightBlue' },
            { text: 'Remove', onClick: onRemove, theme: 'lightBlue' },
          ] }
        />
      </div>
    )

    return (
      <SidebarPopup
        corners={ corners }
        hidePopupTimeoutId={ hideTimeoutId }
        onHidePopup={ onHidePopup }
        onRegisterHideTimeout={ onRegisterHideTimeout }
      >
        <SidebarPopupHeader
          title={ isOnFeedPage && relation.slug === 'everyone' ? 'Everyone' : relation.name }
          left={
            !!onBackButtonClick && (
              <SidebarPopupBackButton onClick={ onBackButtonClick } />
            )
          }
          right={
            !isOnFeedPage && (
              <PopupPeergroupSize
                size={ peergroup.size }
                color={ isYourPeers ? 'coral' : 'merlot' }
              />
            )
          }
        />
        <PeerDefinition
          isRange
          { ...preparePeerDefinitionProps(peergroup) }
        />

        <footer className={ styles.footer }>
          { selectRelationButton }
          { selectFeedfilterButton }
          { randomizeButton }
          { customGroupButtons }
        </footer>
      </SidebarPopup>
    )
  }
}

type PopupPeergroupSizeProps = {
  size: number
  color: BrandColor
}
export const PopupPeergroupSize: FC<PopupPeergroupSizeProps> = (props) => {
  const { size, color } = props
  const className = cn(styles.groupSize, styles[color])

  return (
    <span className={ className }>{ shortenNumber(size) } <br />people</span>
  )
}
